import { styled } from "@mui/material";
import ActionButton from "controls/global/action-button";
import React from "react";
import {
  colors,
  fontSize,
} from "theme/defaultStyle";
import EyeIcon from "theme/icons/EyeIcon";
import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import { PERMISSIONS } from "utils/data/enum";

type Props = {
  onNavigate: (url: string) => void;
  disabled?: boolean;
};

const StyledButton = styled(ActionButton)({
  "& .MuiSvgIcon-root": {
    color: colors.blue01,
    fontSize: fontSize.xlarge0,
  },
});

const ViewPendingPayment = ({ onNavigate, disabled = false }: Props) => {
  const handleNavigate = () => {
    onNavigate("/pendingpay");
  };
  const [{ profileSettings }] = useProfileSettingsCache();
  const permissionCodes = profileSettings?.userPermissionItemTypes as string[];
  const hasBillingViewAccess = permissionCodes?.includes(PERMISSIONS.BILLING_VIEW);
  return (
    <StyledButton
      variant="outlined"
      color="secondary"
      onClick={handleNavigate}
      startIcon={<EyeIcon />}
      disabled={disabled || !hasBillingViewAccess}
    >
      View Pending Payments
    </StyledButton>
  );
};

export default ViewPendingPayment;
